import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { createQueryData } from '../helpers/createQueryData';

const endPoint =
  'Acceptance/view_get_detailed_information_acceptance_by_address_id';

const { useQuery, createKey } = createQueryData({ endPoint });

const useRoomInfoQuery = ({ params: { addressId } = {}, options }) => {
  return useQuery({
    params: { addressId },
    options: {
      enabled: Boolean(addressId),
      staleTime: 1000,
      ...options,
    },
  });
};

const useInvalidateRoomInfo = () => {
  const queryClient = useQueryClient();

  return useCallback(
    ({ addressId }) => {
      queryClient.invalidateQueries(createKey({ addressId }));
    },
    [queryClient]
  );
};

export { useRoomInfoQuery, useInvalidateRoomInfo };
